/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import {propsAreEqual_NoRerenderNeeded} from '../reducer/util'

import React, { Component } from 'react'
import { Dropdown, Form, Button, Icon, Popup } from 'semantic-ui-react'
import _ from 'lodash'

export class DropDown extends Component {
  constructor() {
    super()
    this.state = {}
  }
  errorPopup = error => {
    return (
      <Popup trigger={<Icon name='warning sign' color='red' />} 
      basic={true} //no arrow
      content={error || ''} />
    )
  }
  getDropDownText = (option) => {
    if (option.stringVal) { // If there is a stringVal, use that
      return option.stringVal
    } else {
      // If not stringVal, it is likely a Master
      if (option.id && !option.description) { // If master (ie there is an id), return only the id if there is no description
        return option.id
      } else if (option.id && option.description) { // Return combo of both is id and description are present
        if(option.hidePrefixOnOption)return option.description
        return option.id + ' - ' + option.description
      } else if (option.value && option.description) { // Return combo of both is id and description are present
        if(option.hidePrefixOnOption)return option.description
        return option.value + ' - ' + option.description
      } else if(option.key){ // when using KeyValueData
        return option.key
      } else if(option.description){
        return option.description
      }
    }
    // If no matches were found
    return option
  }
  shouldComponentUpdate(nextProps, nextState){
    if(window.slowstate)return true;

    return !propsAreEqual_NoRerenderNeeded(this.props,nextProps) || !propsAreEqual_NoRerenderNeeded(this.state,nextState);

  }
  

  getDropDownValue = (option) => {
    if (option.stringVal) { // If there is a stringVal, use that
      return option.stringVal
    } else {
      // If not stringVal, it is likely a Master
      if (option.id) { // If master (ie there is an id), return the id
        return option.id
      } else if (option.value) { // If master (ie there is an value), return the value
        return option.value
      }
    }
    // If no matches were found
    return option
  }

  handleChange = (e, { value }) => {
    this.props.onChange(value)
    document.getElementsByClassName('active-label')[0] &&
      document
        .getElementsByClassName('active-label')[0]
        .classList.remove('active-label')
    this.setState({currentValueRerenderer:Date.now()})
  }
  onKeyPress = (e) => {
    if(!e.currentTarget.children)alert("ERROR WITH DROPDOWN COMPONENT")
    this.props.onKeyPress(e.currentTarget.children[0].value)
    document.getElementsByClassName('active-label')[0] &&
      document
        .getElementsByClassName('active-label')[0]
        .classList.remove('active-label')
        this.setState({currentValueRerenderer:Date.now()})
  }

  render() {
    const {
      label,
      className,
      columnClassName,
      width,
      data,
      disabled,
      direction,
      labelClassName,
      centerSelect,
      onChange,
      text,
      onBlur,
      id,
      onButtonClick,
      onKeyPress,
      button,
      handleFocus,
      labelIcon,
      shipmentId,
      error,
      errors,
      subLabelText,
      noTextDisplay
    } = this.props
    let redBgColor = "";
    if(errors && errors.length){
      redBgColor = "redBgColor";
    }
    let drop_data = data === undefined ? [1, 2] : data
    const options = _.map(drop_data, (item, index) => {
      let newText = this.getDropDownText(item);
      if(newText.indexOf("AMS_OR ")==0){
        newText = newText.replaceAll("AMS_OR ","AMS_OR1 ")
      }
      return ({
      key: index,
      text: newText,
      value: this.getDropDownValue(item),
      disabled: item.disabled
    })})
    return (
      <React.Fragment>
        <Form.Field
          width={width}
          className={`floating-select limitDropdownWidth ${noTextDisplay?' noTextDisplay ':' '} ${centerSelect &&
            'floating-select-center'} ${columnClassName || ''}`}
        >
          {label && (
            <label
              id={`${id}label`}
              htmlFor='floatField'
              className={'label-dropdown name-label es ' + labelClassName || ''}
            >
              {error && this.errorPopup(error)}
              {errors && !!errors.length && this.errorPopup(errors[0])}
              {label}
              {labelIcon && labelIcon}
            </label>
          )}
          <Dropdown
            lazyLoad={true}
            closeOnChange
            selectOnBlur={false}
            selectOnNavigation={false}
            scrolling
            search={(objectListSearched,text)=>{
              console.log('textobjectListSearched: ', text);
              console.log('objectListSearched: ', objectListSearched);
              let retme= objectListSearched.filter((oneitem)=>{
                let stringcleanup = function(str){
                  return (str||"").toLowerCase().replaceAll("_"," ").replaceAll("-"," ")
                }
                return oneitem && stringcleanup(JSON.stringify(oneitem))
                  .includes(stringcleanup(text).trim())
              })  
              return retme

            }}
            selection
            options={options}
            onChange={(e, { value })=>{
              if(disabled)return;
              onChange && this.handleChange(e, { value });
              this.setState({isCurrentlyFocused:false});
              setTimeout(()=>{
                document.activeElement.blur()
              },10)
            }}
            onKeyUp={onKeyPress && this.onKeyPress}
            value={text}
            text={text}
            id={id + shipmentId}
            name={id + shipmentId}
            open={this.state.isCurrentlyFocused && !disabled}
            direction={direction}
            disabled={disabled}
            className={className+" "+redBgColor}
            upward={false}
            onBlur={(e) => {
              if(disabled)return;
              onBlur && onBlur(e)
              document.getElementsByClassName('active-label')[0] && document.getElementsByClassName('active-label')[0].classList.remove('active-label')
              this.setState({isCurrentlyFocused:false, currentValueRerenderer:Date.now()})
            }}
            onFocus={event => {
              event.target && event.target.setAttribute("autocomplete", "nope");
              document.getElementsByClassName('active-label')[0] && document.getElementsByClassName('active-label')[0].classList.remove('active-label')
              document.getElementById(id + shipmentId).previousSibling && document.getElementById(id + shipmentId).previousSibling.classList.add('active-label')
              handleFocus && handleFocus(event)
              this.setState({isCurrentlyFocused:true,currentValueRerenderer:Date.now()})
              // setINPUTID && setINPUTID(id + shipmentId)
            }}
            onMouseOver={e => {
              this.setState({currentValueRerenderer:Date.now()})
            }}
            onMouseDown={e => {
              e.stopPropagation()
              // penClicked && penClicked(e)
              this.setState({currentValueRerenderer:Date.now()})
            }}
          />
          {subLabelText && <p className='right-icon'>{subLabelText}</p>}
          {button && (
            <Button
              basic
              color='blue'
              className='openButton'
              onClick={e => onButtonClick(e)}
            >
              {button}
            </Button>
          )}
        </Form.Field>
      </React.Fragment>
    )
  }
}

export default DropDown
